import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { patchInvestigation } from "../../../../../apis";
import { Box, Typography } from "@mui/material";
import { InvestigationSectionHeader } from "../components/InvestigationSectionHeader";
import { InvestigationAdvertisement } from "../components/InvestigationAdvertisement";
import { EvaluationsView } from "./EvaluationsView";
import { AddEvaluation } from "./AddEvaluation";
import { Separator } from "../components/InvestigationComponents";
import { useConstants } from "../Main/useConstants";
import _ from "lodash";

// Evaluacion inicial
export const initEvaluation = {
  priority: "",
  policies: {
    details: "",
    list: [],
  },
  measures: {
    details: "",
    list: [],
  },
  actions: {
    details: "",
    list: [],
  },
}

// Componente de evaluacion completo
export const Evaluation = ({ 
  investigation, 
  setInvestigation, 
  justView = false, 
  handleSelectedSection,
}) => {

  const [t] = useTranslation("investigation");
  const { enums } = useConstants();
  const [evaluations, setEvaluations] = useState(investigation.evaluation ?? _.cloneDeep(initEvaluation));
  const [causes, setCauses] = useState(investigation.causes ?? []);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (investigation.evaluation != null) {
      setEvaluations(investigation.evaluation);
    } else {
      setEvaluations(_.cloneDeep(initEvaluation))
    }
  }, [investigation?.evaluation]);

  useEffect(() => {
    if (investigation.causes != null) {
      setCauses(investigation.causes);
    } else {
      setCauses([])
    }
  }, [investigation?.causes]);

  const handleSaveEvaluations = async (newEvaluations, newCauses) => {

    const objToSave = {
      folder: {
        evaluation: newEvaluations,
        causes: newCauses,
      },
    };

    try {
      await patchInvestigation(investigation.alias, objToSave);
      setInvestigation({ ...investigation, evaluation: newEvaluations, causes: newCauses });
    } catch (error) {
      console.error(error);
    }
  };

  const someEvaluationExist = useMemo(() => {
    let countEvaluations = 0;
    countEvaluations += evaluations?.policies?.list?.length ?? 0;
    countEvaluations += evaluations?.measures?.list?.length ?? 0;
    countEvaluations += evaluations?.actions?.list?.length ?? 0;
    countEvaluations += investigation.causes?.length ?? 0;
    return countEvaluations > 0;
  }, [evaluations]);

  return (
    <Box className="dyTheme1" p={1}>

      {
        !isEditing && !justView &&
        <InvestigationSectionHeader
          text={t("evaluation.add_information_to_start_investigation")}
          buttonText={!someEvaluationExist ? t("evaluation.evaluate_case") : t("evaluation.edit_evaluation")}
          buttonIcon="outline_task"
          onClick={() => setIsEditing(true)}
          type="evaluation"
        />
      }

      {
        justView &&
        <Separator
          text={t("sections.evaluation")}
          icon="outline_task"
          iconButton={handleSelectedSection ? "outline_edit" : undefined}
          onClick={handleSelectedSection ? () => handleSelectedSection(enums.sections.caseEvaluation) : undefined}
          sx={{ marginBottom: 1.5 }}
        />
      }

      {
        !someEvaluationExist && !isEditing &&
        <InvestigationAdvertisement
          title={t("evaluation.no_evaluation_case")}
          description={t("evaluation.define_priority_investigation")}
        />
      }

      {
        someEvaluationExist && !isEditing &&
        <EvaluationsView
          evaluations={evaluations}
          causes={causes}
          justView={justView}
        />
      }

      {
        isEditing && 
        <AddEvaluation
          investigation={investigation}
          handleSaveEvaluations={handleSaveEvaluations}
          setIsEditing={setIsEditing}
        />
      }

    </Box>
  );
};